import React from 'react';

interface BadgeProps {
  /**
   * The content to be displayed in the badge
   */
  children: React.ReactNode;
  /**
   * The visual variant of the badge
   * @default "default"
   */
  variant?: 'default' | 'success' | 'warning' | 'destructive' | 'info';
  /**
   * Additional CSS class names to apply to the badge
   */
  className?: string;
}

/**
 * Badge component for displaying short status text
 * Provides consistent styling across the application
 */
export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  className = '' 
}) => {
  const baseStyles = "inline-flex items-center text-xs font-medium px-3 py-1 rounded-lg";
  
  const variantStyles = {
    default: "bg-primary/20 text-primary-foreground",
    success: "bg-success/20 text-success-foreground",
    warning: "bg-warning/20 text-warning-foreground",
    destructive: "bg-destructive/20 text-destructive-foreground",
    info: "bg-info/20 text-info-foreground"
  };

  const combinedStyles = `${baseStyles} ${variantStyles[variant]} ${className}`;

  return (
    <span className={combinedStyles}>
      {children}
    </span>
  );
};

export default Badge;